import { getRequest } from '../../../utils'
import { Article } from './types/article'

export interface GetIntercomArticlesResponseData {
  data: { articles: Article[] }
}

export const getIntercomArticles = (searchQuery: string): Promise<GetIntercomArticlesResponseData> => {
  return getRequest(`/intercom/articles?q=${searchQuery}`)
}
